import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const CabinetContestInformation = () => {
    const { t } = useTranslation();
    const contestInfo = useSelector((store) => store.cabinet.contestInfo);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Информация о розыгрышах')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemName}`}>{t('Всего денег в казне')}:</div>
                        <div className={`${Styles.contentBoxItemValue}`}>{`$${contestInfo?.total_money ?? '0'}`}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemName}`}>{t('Всего мест')}:</div>
                        <div className={`${Styles.contentBoxItemValue}`}>{`${contestInfo?.total_places ?? '0'}`}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemName}`}>{t('Количество билетов')}:</div>
                        <div className={`${Styles.contentBoxItemValue}`}>{`${contestInfo?.tickets ?? '0'}`}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemName}`}>{t('Ваш шанс на победу')}:</div>
                        <div className={`${Styles.contentBoxItemValue}`}>{`${contestInfo?.winning_percentage ?? '0'}%`}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetContestInformation;